/**
 * @file 프로젝트 채널의 진행 단계 판정 — 사이드바 분류의 단일 출처.
 *
 * <p>사이드바(구간 분류)와 채널 목록 페이지가 같은 기준을 써야 하므로 모듈로 분리했다.
 * 한쪽만 고치면 "진행중에 있는데 D+가 떠 있는" 식으로 조용히 어긋난다.
 */

import { daysUntil } from "./dday";

/**
 * 프로젝트 채널의 단계 결정 — 사이드바 분류·상태 dot·라벨이 모두 이 함수 결과를 기준으로 동작한다.
 *
 * <ul>
 *   <li>{@code "finished"} — archived 이거나 마감일이 오늘보다 이전</li>
 *   <li>{@code "undated"}  — 시작일·마감일 둘 다 미지정 (기본 숨김 토글로 모음)</li>
 *   <li>{@code "upcoming"} — 시작일이 명시되어 있고 오늘보다 이후</li>
 *   <li>{@code "ongoing"}  — 그 외 (시작일 ≤ 오늘 또는 마감일만 지정되어 진행중)</li>
 * </ul>
 */
export function projectPhase(channel) {
    if (channel.archived || channel.deadlineExpired) return "finished";
    /*
     * 날짜 비교는 daysUntil 로 — 여기도 `new Date("2026-09-30")` 을 쓰고 있었다.
     * 그건 UTC 자정으로 파싱돼 KST 로는 그날 09:00 이라, 자정으로 맞춘 today 와 비교할 때
     * 마감 당일 오전에 아직 "진행중" 으로 남는 식으로 하루가 밀렸다.
     */
    if (channel.deadlineDate && daysUntil(channel.deadlineDate) < 0) return "finished";
    if (!channel.startDate && !channel.deadlineDate) return "undated";
    if (channel.startDate && daysUntil(channel.startDate) > 0) return "upcoming";
    return "ongoing";
}
